var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.company
    ? _c(
        "div",
        { staticClass: "w-full" },
        [
          _vm.managerDatabase === true
            ? _c(
                "p",
                {
                  staticClass: "font-semibold w-max-content custom-title mt-1",
                },
                [_vm._v(" Resources ")]
              )
            : _vm._e(),
          _c(
            "DefaultContentLayout",
            [
              _c(
                "div",
                [
                  _c("ContractorCollectionFilters", {
                    attrs: {
                      currentUserId: _vm.currentUser.id,
                      hideManagersFilter: _vm.isManager,
                      parentInputClass: "pb-3 flex-wrap",
                      filters: _vm.directoryFilters,
                      filterClass: "w-max-content",
                    },
                    on: {
                      filtersChanged: _vm.updateFilters,
                      resetFilters: _vm.resetFilters,
                    },
                  }),
                ],
                1
              ),
              _c(
                "LoadingOverlay",
                {
                  attrs: {
                    hasData: _vm.hasData,
                    loading: _vm.loading,
                    spinnerCentered: "",
                  },
                },
                [
                  _c("ActionPanel", {
                    staticClass: "mb-6 topScrollAction",
                    attrs: {
                      total: _vm.paginationConfig.total,
                      pageName: "Total Resources",
                    },
                  }),
                  _vm.empty
                    ? _c("EmptyListPlaceholder", {
                        attrs: {
                          title: _vm.emptyListPlaceholder,
                          subtitle: _vm.emptyListSubtitle,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image",
                              fn: function () {
                                return [_c("EmptyListImageContractors")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          143841379
                        ),
                      })
                    : _vm._e(),
                  _c("ElementsSizeProvider", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ setSize, getBlockMinHeight }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "flex flex-wrap gap-4 topScroll",
                                },
                                _vm._l(
                                  _vm.contractors,
                                  function (contractor, index) {
                                    return _c(
                                      "CompanyContractorsCollectionCard",
                                      {
                                        key: contractor.id,
                                        attrs: {
                                          contractor: contractor,
                                          ratingTotal: contractor.ratingTotal,
                                          company: _vm.company,
                                          hasAllResourceAccess:
                                            _vm.hasAllResourceAccess,
                                          currentUser: _vm.currentUser,
                                          managerDatabase: _vm.managerDatabase,
                                          userUpdatedDate:
                                            contractor.user.updated_at,
                                          nameBlockMinHeight: getBlockMinHeight(
                                            { index, blockName: "name" }
                                          ),
                                          skillsBlockMinHeight:
                                            getBlockMinHeight({
                                              index,
                                              blockName: "skills",
                                            }),
                                          managersBlockMinHeight:
                                            getBlockMinHeight({
                                              index,
                                              blockName: "managers",
                                            }),
                                        },
                                        on: {
                                          "update:nameBlockMinHeight": (
                                            minHeight
                                          ) =>
                                            setSize({
                                              index,
                                              blockName: "name",
                                              minHeight,
                                            }),
                                          "update:skillsBlockMinHeight": (
                                            minHeight
                                          ) =>
                                            setSize({
                                              index,
                                              blockName: "skills",
                                              minHeight,
                                            }),
                                          "update:managersBlockMinHeight": (
                                            minHeight
                                          ) =>
                                            setSize({
                                              index,
                                              blockName: "managers",
                                              minHeight,
                                            }),
                                          cardDataUpdated: function ($event) {
                                            return _vm.$apollo.queries.contractors.refetch()
                                          },
                                        },
                                      }
                                    )
                                  }
                                ),
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3224007492
                    ),
                  }),
                  _c("CardPagination", {
                    attrs: { config: _vm.paginationConfig },
                    on: {
                      "update:config": function ($event) {
                        _vm.paginationConfig = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }